import React from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/ui-kit";
import ChangePasswordForm from "@/components/ChangePasswordForm";
import MfaSettings from "@/components/MfaSettings";

export default function Account() {
  const { user } = useAuth();
  const location = useLocation();
  const mfaRequired = new URLSearchParams(location.search).get("mfa") === "required";
  const roleLabel = { agency_admin: "Agency Admin", dispatcher: "Dispatcher", client_user: "Client Portal", driver: "Driver" }[user?.role] || user?.role;

  const mfaSection = (
    <section
      className={`bg-white border rounded-md p-6 mb-6 max-w-md ${mfaRequired ? "border-amber-300" : "border-slate-200"}`}
      data-testid="account-mfa-section"
    >
      <div className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-500 mb-3">Two-step sign-in (MFA)</div>
      <MfaSettings />
    </section>
  );

  return (
    <div data-testid="account-page">
      <PageHeader subtitle="Your account" title="Account" />

      {mfaRequired && (
        <div
          className="mb-6 max-w-md text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-md px-3 py-2"
          data-testid="account-mfa-banner"
        >
          Finish MFA setup to continue. Your agency requires it for your role.
        </div>
      )}

      {mfaRequired && mfaSection}

      <section className="bg-white border border-slate-200 rounded-md p-6 mb-6 max-w-md">
        <div className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-500 mb-3">Signed in as</div>
        <div className="text-sm text-slate-900 font-medium">{user?.name}</div>
        <div className="text-sm text-slate-600">{user?.email}</div>
        <div className="text-xs text-slate-500 mt-1 uppercase tracking-wider">{roleLabel}</div>
      </section>

      {!mfaRequired && mfaSection}

      <section className="bg-white border border-slate-200 rounded-md p-6 max-w-md">
        <div className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-500 mb-3">Change password</div>
        <p className="text-sm text-slate-600 mb-4">Changing your password signs out every other device and browser where you are logged in.</p>
        <ChangePasswordForm />
      </section>
    </div>
  );
}
